import button from './components/button';
import headerImage from './components/headerImage';
import style from './components/style';
import footer from './components/footer';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'This month on Real Links',
  value: 'stats',
  subject: 'This month on Real Links',
  mjml(params) {
    const { brandingSettings: branding } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section
          padding="54px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
          background-size="100%"
          background-repeat="no-repeat"
        >
          <mj-column>
           <mj-text
            align="center"
            line-height="34px"
            color="#ffffff"
            font-size="28px"
            letter-spacing="2px"
          ><b>${slots[0].content}</b></mj-text>
          </mj-column>
        </mj-section>

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
            <div class="text-content">${slots[1].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          <mj-column width="100%">
            ${button('Login', branding)}
          </mj-column>
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Header Text',
      type: 'input',
      defaultContent: 'Thank You',
    },
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
      <h1>This month on Real Links</h1>
      <ul>
        <li>We've had [xx] referred candidates</li>
        <li>We've had [xx] introductions</li>
        <li>We've filled [xx] open roles</li>
        <li>We've shared [xx] pieces of content</li>
      </ul>
      <p>And we couldn't have done it without you!</p>
      <p>[Because we've had such a great month, we want to treat
      everyone who's contributed]</p>
      `,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/stats.js